module.exports = __webpack_public_path__ + "static/img/16.709f481.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/5/2/4/zh/16.png
// module id = LKsQ
// module chunks = 0